import React from 'react';
import DogImage from '../assets/pett.png';

const ImageComponent = () => {
  return (
    <div className="bg-[#F8E8D9] flex justify-center items-center h-1/2">
      <img
        src={DogImage}
        alt="Cute Dog"
        className="w-[406px]"  // Set image width to 600px
      />
    </div>
  );
};

export default ImageComponent;
